import en from './en/common';
import ka from './ka/common';

const messages = {
  en: {
    common: en,
  },
  ka: {
    common: ka,
  },
};

export default messages;
